import { cn } from "@omni/utils/styles";

import { FinishSkeleton } from "@/components/PaintConfigurator/components/products/components/filters/components/finish/finish.skeleton";
import { FilterButton } from "@/components/PaintConfigurator/components/shared/filter/filterButton";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useSkeleton } from "@/utils/hooks/useSkeleton.hook";

import { useProductsContext } from "../../../../context/products.context";

type Props = {
    className?: string;
};

const FinishFilter = ({ className }: Props) => {
    const { t } = useGranite();

    const { finishes, selectedFinish, setSelectedFinish, isLoading } =
        useProductsContext();

    const { showSkeleton, showContent } = useSkeleton(isLoading);

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            <div className={cn("tw:font-bold")}>
                {t("paintConfigurator.finish.label")}
            </div>
            <div className={cn("tw:flex tw:gap-2 tw:flex-wrap")}>
                {showContent &&
                    Array.from(finishes.entries()).map(([finish, _]) => (
                        <FilterButton
                            label={finish}
                            isSelected={selectedFinish?.value === finish}
                            key={finish}
                            onClick={() => setSelectedFinish(finish)}
                        >
                            {finish}
                        </FilterButton>
                    ))}
                {showSkeleton && <FinishSkeleton />}
            </div>
        </div>
    );
};

export { FinishFilter };
